var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticStyle: { height: "100%" } },
    [
      _c("el-aside", { attrs: { width: "200px" } }, [
        _c("div", { staticClass: "main-title" }, [
          _c("span", [_vm._v("中公教育")]),
          _vm._v("后台\n      "),
          _c("i", {
            staticClass: "el-icon-menu",
            on: {
              click: function($event) {
                return _vm.postMessage("showNavList")
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "my_collection" }, [_vm._v("我的收藏")]),
        _vm._v(" "),
        _vm.network &&
        _vm.userConfig &&
        _vm.userConfig.config &&
        _vm.userConfig.config.length > 0
          ? _c(
              "div",
              { staticClass: "collection_nav" },
              [
                _c(
                  "draggable",
                  {
                    attrs: { options: { animation: 200 } },
                    on: { update: _vm.datadragEnd },
                    model: {
                      value: _vm.userConfig.config,
                      callback: function($$v) {
                        _vm.$set(_vm.userConfig, "config", $$v)
                      },
                      expression: "userConfig.config"
                    }
                  },
                  _vm._l(_vm.userConfig.config, function(item) {
                    return _c(
                      "p",
                      {
                        key: item.url,
                        class: { active: item.url == _vm.activeNavUrl },
                        on: {
                          click: function($event) {
                            return _vm.goNav(item)
                          }
                        }
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              disabled: true,
                              effect: "dark",
                              content: item.menuName,
                              placement: "top-start"
                            }
                          },
                          [
                            _c("span", { staticClass: "nav_text" }, [
                              _vm._v(_vm._s(item.menuName))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu_group" }, [
                          _c("i", {
                            staticClass: "edit_collection_nav el-icon-edit",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.editNavName(item)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "del_collection_nav el-icon-close",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.delNav(item)
                              }
                            }
                          })
                        ])
                      ],
                      1
                    )
                  }),
                  0
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.network &&
        _vm.userConfig &&
        _vm.userConfig.config &&
        _vm.userConfig.config.length == 0 &&
        _vm.presetConfigList.length > 0
          ? _c("div", { staticClass: "no_collection" }, [
              _c("p", [
                _vm._v("请自定义导航内容"),
                _c("br"),
                _vm._v("或选择你的角色")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "recommend_nav" },
                _vm._l(_vm.presetConfigList, function(item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      on: {
                        click: function($event) {
                          return _vm.setPresetConfig(item.config)
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.name))]
                  )
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.network
          ? _c("div", { staticClass: "network_error" }, [
              _c("p", [_vm._v("网络错误,点击重试")]),
              _vm._v(" "),
              _c("span", {
                staticClass: "el-icon-refresh-right",
                on: {
                  click: function($event) {
                    return _vm.GetUserConfig()
                  }
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "aside_menu" }, [
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  return _vm.postMessage("showSystemNav")
                }
              }
            },
            [
              _c("i", { staticClass: "el-icon-sort" }),
              _vm._v("\n        系统导航")
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c(
            "el-header",
            {
              staticStyle: {
                "background-color": "#fff",
                "border-bottom": "1px solid #eee"
              }
            },
            [
              _c(
                "el-row",
                {
                  staticClass: "row-bg",
                  attrs: {
                    type: "flex",
                    justify: "space-between",
                    align: "middle"
                  }
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 3, offset: 21 } },
                    [
                      _c(
                        "el-dropdown",
                        [
                          _c("span", { staticClass: "el-dropdown-link" }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-weight": "700",
                                  "font-size": "16px",
                                  cursor: "pointer"
                                }
                              },
                              [
                                _vm._v(_vm._s(_vm.name)),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right"
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c("el-dropdown-item", [
                                _c("span", { on: { click: _vm.quitSystem } }, [
                                  _vm._v(
                                    "\n                  退出登录\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-main", { staticClass: "main-content" }, [_c("router-view")], 1)
        ],
        1
      ),
      _vm._v(" "),
      _c("edit-nav-alias", {
        attrs: { "nav-config": _vm.navConfig, "show-edit": _vm.showEditBox },
        on: { handleCancle: _vm.handleCancel, handleConfirm: _vm.handleConfirm }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1badc801", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1badc801","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
// module id = null
// module chunks = 